/**
 *
 * http配置
 */

import axios from 'axios';
import store from '../../vuex/store';
import crypto from '@/assets/js/aes'
export default {
  // fetchPost  请求方式
  fetchPost: function (url, params, query) {
    let urls = url;
    if (query) {
      urls = url + '?' + query;
    } else {
      urls = url;
    }
    return new Promise((resolve, reject) => {
      axios.post(urls, params)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // GET 请求方式
  fetchGet: function (url, params, header) {
    console.log(store.state.intercept);
    return new Promise((resolve, reject) => {
      axios.get(url, {
          params: params,
          responseType: header ? header.responseType : 'json',
          headers: {
            Intercept: store.state.intercept,
            Environment: this.getEnvironment()
          }
        })
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEnvironment(){
    //拼合token并加密编码
    let channeltokenObj = {key : 1, value : {user_agent : navigator.userAgent, version : navigator.userAgent}};
    channeltokenObj = crypto.Encrypt(JSON.stringify(channeltokenObj));
    channeltokenObj = encodeURIComponent(channeltokenObj);
    return channeltokenObj;
  }
};
